import { render, staticRenderFns } from "./GameBtn.vue?vue&type=template&id=6c978de2&scoped=true&"
import script from "./GameBtn.vue?vue&type=script&lang=js&"
export * from "./GameBtn.vue?vue&type=script&lang=js&"
import style0 from "./GameBtn.vue?vue&type=style&index=0&id=6c978de2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c978de2",
  null
  
)

export default component.exports